import { gql } from '@apollo/client'
import { PrivacyNoticeFragment } from '@/fragments'

export default gql`
  query signupNotices {
    signupNotices {
      terms {
        ...privacy_notice
      }
      privacyPolicy {
        ...privacy_notice
      }
      marketing {
        ...privacy_notice
      }
    }
  }
  ${PrivacyNoticeFragment}
`
